export interface AreaData {
  id: string;
  name: string;
  state: State;
  zones: Zone[] | undefined | null;
  troubles: Trouble[] | undefined | null;
}

export interface State {
  armed: boolean;
  troubles?: Trouble[];
  alarm: boolean | undefined | null;
  exit_delay_active: boolean | undefined | null;
  entry_delay_active: boolean | undefined | null;
  exit_delay_expires_in_seconds: number | undefined | null;
  entry_delay_expires_in_seconds: number | undefined | null;
}

export interface Zone {
  id: string;
  type: string;
  name: string;
  stay_arm: boolean | undefined | null;
  reportcode: number | undefined | null;
  persistent: boolean | undefined | null;
  io: string | undefined | null;
  sn: string | undefined | null;
  group: string | undefined;
  state: ('open' | 'closed' | 'short_circuit' | 'open_circuit');
  overridden: boolean | undefined | null;
}

export interface Trouble {
  id: string;
  type_id: number;
  type: string;
  text: string | undefined | null;
  created: string;
  resolved: string | undefined | null;
  acked: string | undefined | null;
  ack_user: any | undefined | null;
  overridden: boolean | undefined | null;
  zone: Zone | undefined | null;
}
